<template>
    
    <div class="row hp-authentication-page">
        <div class="hp-bg-black-20 hp-bg-color-dark-90 col-lg-6 col-12 mm-none">
            <div class="row hp-image-row h-100 px-8 px-sm-16 px-md-0 pb-32 pb-sm-0 pt-32 pt-md-0">
                <div class="hp-logo-item m-16 m-sm-32 m-md-64 w-auto px-0 col-12">
                    <!-- <div class="hp-header-logo d-flex align-items-center">
                        <a href="#" class="position-relative">

                            <img class="hp-logo hp-sidebar-visible hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-visible hp-dark-block" src="./img/favicon.png" alt="logo">
                            
                            <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block" src="./img/favicon.png" alt="logo">
                        </a>

                        <a href="#" target="_blank" class="d-flex">
                            <span class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1">v.1.0</span>
                        </a>
                    </div> -->
                </div>

                <div class="col-12 px-0">
                    <div class="row h-100 w-100 mx-0 align-items-center justify-content-center bg-1" style="background-size: cover; background-repeat: no-repeat; background-position: start;">
                        <div class="hp-bg-item text-center mb-32 mb-md-0 px-0 col-12">
                            <div style="display: flex; justify-content: center; align-items: center; margin-top: 400px;">
                                <img src="../assets/img/logo_big.png" alt="" width="120px">
                                <h1 class="titleH" style="text-align: center; color: #fff; font-size: 90px; margin-top: 50px; margin-left: -25px;">aesnap</h1>
                            </div>
                        </div>

                        <div class="hp-text-item text-center col-xl-9 col-12">
                            <h2 class="hp-text-color-blac-100 hp-text-color-dark-0 mx-16 mx-lg-0 mb-16" style="color: #fff;"> </h2>
                            <p class="h4 mb-0 fw-normal hp-text-color-blac-80 hp-text-color-dark-30" style="color: #fff;"></p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="col-12 col-lg-6 py-sm-64 py-lg-0">
            <div class="row align-items-center justify-content-center h-100 mx-4 mx-sm-n32">
                <div class="col-12 col-md-9 col-xl-7 col-xxxl-5 px-8 px-sm-0 pt-24 pb-48">

                    <!-- <div style="display: flex; justify-content: center; align-items: center;" class="dd-none">

                        <img src="../assets/img/favicon.png" alt="" style="width: 70px; margin-bottom: 5px;" class="dd-none">

                    </div> -->
                    
                    <h1 class="mb-0 mb-sm-24 mainTitle mm-none titleH" style="margin-top: 30px;   ">Welcome Back!</h1>
                    <h1 class="mb-0 mb-sm-24 mainTitle dd-none titleH" style="margin-top: 50px;  ">Welcome Back!</h1>

                    <!-- <p class=" text-black-60 subTitle" style=" margin-bottom: 40px;">Ready to dive back into the world of creativity, connection, and inspiration? Log in to your Baesnap account and pick up right where you left off.</p> -->

                    <p class=" text-black-60 subTitle mm-none" style=" margin-bottom: 40px;"> Log in to your Baesnap account and pick up right where you left off.</p>

                    <p class=" text-black-60 subTitle dd-none" style=" margin-bottom: 40px;"> </p>

                    <form class="mt-16 mt-sm-32 mb-8" @submit.prevent="signIn">

                        <div class="mb-16">
                            <label for="registerEmail" class="form-label">Email</label>
                            <input type="email" class="form-control" id="registerEmail" style="padding-top: 5px; padding-bottom: 5px;" placeholder="youremail@example.com" v-model="email" required>
                        </div>

                        <div class="mb-16" style="position: relative;">
                            <label for="registerPassword" class="form-label" >Password </label>
                            <input type="text" class="form-control" id="password" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Minimum of 8 characters" v-model="password" required>
                            <div style="position: absolute; cursor: pointer; top: 45px; right: 20px;">
                                <i class="hp-text-color-dark-0 iconly-Light-Show" id="showIcon" @click="passwordMethod"></i>
                                <i class="hp-text-color-dark-0 iconly-Light-Hide" id="hideIcon" @click="passwordMethod"></i>
                            </div>
                        </div>

                        <div class="row align-items-center justify-content-between mb-16">
                            <div class="col hp-flex-none w-auto">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="exampleCheck1">
                                    <p class="form-check-label ps-4" for="exampleCheck1">Remember me</p>
                                </div>
                            </div>

                            <div class="col hp-flex-none w-auto">
                                <router-link :to="{name: 'forgot-password'}" class="hp-button text-black-80 hp-text-color-dark-40"  style="color: #9146ff !important; "><strong>Forgot Password?</strong></router-link>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-primary w-100" style="color: #fff; margin-top: 30px; padding-top: 20px; padding-bottom: 20px; font-size: larger;">
                            Sign in
                        </button>
                    </form>

                    <div class="col-12 hp-form-info text-center" style="margin-top: 20px;">
                        <p>Not a member yet? <router-link :to="{name: 'sign-up'}" class="hp-text-color-dark-primary-1" style="color: #9146ff;"><strong>Sign up</strong></router-link></p>
                        
                        <div class=" divider mt-32 mb-32" ></div>

                        <div style="width: 100%; justify-content: center; align-items: center; display: flex; margin-top: 20px;">
                            <button @click="googleSignIn" class="btn btn-icon-only rounded-circle btn-outline" style="width: 60px; height: 60px;">
                                <img src="../assets/img/google3.png" alt="" style="width: 20px;">
                            </button>

                            <button @click="metaSignIn" class="btn btn-icon-only rounded-circle btn-outline" style="width: 60px; height: 60px; margin-left: 15px; margin-right: 15px;">
                                <img src="../assets/img/meta.png" alt="" style="width: 25px;">
                            </button>

                            <button @click="appleSignIn" class="btn btn-icon-only rounded-circle btn-outline" style="width: 60px; height: 60px;">
                                <img src="../assets/img/apple.png" alt="" style="width: 20px;">
                            </button>

                        </div>

                        <div class="d-none">
                            <button class="btn btn-outline-primary">
                                <img src="../assets/img/google3.png" alt="" style="width: 20px; margin-right: 10px;">
                                <span>Sign in with Google</span>
                            </button>
                        </div>

                    </div>

                    <div class="mt-120 mt-sm-120 col-12">

                        <!-- <div class="dd-none" style="margin-top: 100px;"></div> -->
                        <div class=" divider mt-18 mb-24" ></div>

                        <div style="display: flex; justify-content: space-evenly; align-items: center; width: 100%;">
                

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/privacy" target="_blank">Privacy</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/terms" target="_blank">Terms</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/complaints" target="_blank">Complaints</a>
                            </p>

                        </div>

                        
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<style scoped>

    .bg-1{
        background-image: url(../assets/img/frontpage-banner-17.png);
    }

</style>

<script>

    import { doc, addDoc, arrayUnion, getDoc, getDocs, query, where, serverTimestamp, updateDoc, collection } from "firebase/firestore"; 
    import {getAuth, signInWithEmailAndPassword, AuthErrorCodes, GoogleAuthProvider, signInWithPopup, TwitterAuthProvider, FacebookAuthProvider, signOut} from "firebase/auth"
    import { db } from '@/firebase';
    import axios from 'axios';
    import { MD5 } from "md5-js-tools";

    export default {

        data(){
            return{
                email: "",
                password: "",
                loadingText:"",
                errorText: "",
                successText: "",
                verifyPin: "",
                pinExpiry: "",
                user: "",
            }
        },

        mounted(){

            this.passwordMethod();

        },

        methods:{
            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
            },

            textToBin(minput) {

                let input = minput.trim();

                let output = "";
                for (var i = 0; i < input.length; i++) {
                    output += input[i].charCodeAt(0).toString(2) + " ";
                }

                return output;
            },

            binToText(minput) {
                let input = minput.trim();
                return input.split(" ").map(function(elem) {
                    return String.fromCharCode(parseInt(elem, 2));
                }).join("")
            },

            passwordMethod(){

                let passwordInput = document.getElementById("password");
                let showIcon = document.getElementById("showIcon");
                let hideIcon = document.getElementById("hideIcon");

                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    showIcon.style.display = 'none';
                    hideIcon.style.display = 'block';
                } 
                else {
                    passwordInput.type = "password";
                    showIcon.style.display = 'block';
                    hideIcon.style.display = 'none';
                }

            },

            signIn(){

                //loading
                this.loadingText = "Sign in...";
                this.$refs.loadingModal.classList.add("bg-active");

                let passwordHash = MD5.generate(String(this.password));

                const auth = getAuth();

                signInWithEmailAndPassword(auth, this.email, passwordHash)
                .then(async (data)=>{

                    //check 2fa
                    const userRef = doc(db, "Users", auth.currentUser.uid);
                    const userSnap = await getDoc(userRef);

                    if (userSnap.exists()) {

                        await updateDoc(userRef, {
                            psw: passwordHash
                        });

                        if(userSnap.data().verified == "no"){
                            sessionStorage.setItem("email", this.email);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            sessionStorage.setItem("refCount", "10");
                            this.$router.push({name: 'verify'});
                            this.$refs.loadingModal.classList.remove("bg-active");
                            return;
                        }

                        if(userSnap.data().activityMonitor == "yes"){
                            //ip
                            this.updateIp(auth.currentUser.uid);
                        }

                        if(userSnap.data().auth == "yes"){

                            sessionStorage.setItem("email", this.email);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            this.$router.push({name: 'auth'});
                        }
                        else{
                            
                            sessionStorage.setItem("profilePic", userSnap.data().profilePic);
                            sessionStorage.setItem("profileBackground", userSnap.data().profileBackground);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            sessionStorage.setItem("userName", userSnap.data().displayId);
                            sessionStorage.setItem("fanCount", userSnap.data().fanCount);
                            sessionStorage.setItem("followingCount", userSnap.data().followingCount);
                            sessionStorage.setItem("followersCount", userSnap.data().followersCount);
                            sessionStorage.setItem("email", userSnap.data().email);
                            sessionStorage.setItem("userType", userSnap.data().type);
                            sessionStorage.setItem("regType", userSnap.data().regType);
                            sessionStorage.setItem("emailNoti", userSnap.data().emailNoti);
                            sessionStorage.setItem("pushNoti", userSnap.data().pushNoti);
                            sessionStorage.setItem("siteNoti", userSnap.data().siteNoti);
                            sessionStorage.setItem("bio", userSnap.data().bio);
                            sessionStorage.setItem("profileType", userSnap.data().profileType);
                            sessionStorage.setItem("bio", userSnap.data().bio);
                            sessionStorage.setItem("refCount", "0");
                            
                            if(localStorage.getItem("otherUserName") != null && localStorage.getItem("otherUserName") != ""){
                                
                                this.$router.push({ name: 'other-profile', params: { id: localStorage.getItem("otherUserName") } });
                                return;

                            }
                            
                            this.$router.push({name: 'home'});
                        }
                    }
                    else{
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        this.errorText = "User does not exist";
                        return;
                    }
                })

                .catch((error)=>{
                    console.log(error.code);
                    switch(error.code){
                        case "auth/invalid-email":
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            this.errorText = "Invalid email or password";
                            break;
                        
                        case "auth/user-not-found":
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            this.errorText = "User not found";
                            break;   
                        
                        case "auth/wrong-password":
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            this.errorText = "Invalid email or password";
                            break;   
                        
                        default:
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            this.errorText = "Invalid email or password";
                            break;    


                    }
                })

                

            },

            async googleSignIn(){

                this.loadingText = "Sign in with Google...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                const googleProvider = new GoogleAuthProvider();

                try {
                    const result = await signInWithPopup(auth, googleProvider)
                    this.user = result.user
                    
                    const userRef = doc(db, "Users", this.user.uid);
                    const userSnap = await getDoc(userRef);

                    if (userSnap.exists()){

                        if(userSnap.data().verified == "no"){
                            sessionStorage.setItem("email", result.user.email);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            sessionStorage.setItem("refCount", "10");
                            this.$router.push({name: 'verify'});
                            this.$refs.loadingModal.classList.remove("bg-active");
                            return;
                        }

                        if(userSnap.data().activityMonitor == "yes"){
                            //ip
                            this.updateIp(this.user.uid);
                        }

                        if(userSnap.data().auth == "yes"){

                            sessionStorage.setItem("email", result.user.email);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            this.$router.push({name: 'auth'});
                        }
                        else{
                            
                            sessionStorage.setItem("profilePic", userSnap.data().profilePic);
                            sessionStorage.setItem("profileBackground", userSnap.data().profileBackground);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            sessionStorage.setItem("userName", userSnap.data().displayId);
                            sessionStorage.setItem("fanCount", userSnap.data().fanCount);
                            sessionStorage.setItem("followingCount", userSnap.data().followingCount);
                            sessionStorage.setItem("followersCount", userSnap.data().followersCount);
                            sessionStorage.setItem("email", userSnap.data().email);
                            sessionStorage.setItem("userType", userSnap.data().type);
                            sessionStorage.setItem("regType", userSnap.data().regType);
                            sessionStorage.setItem("emailNoti", userSnap.data().emailNoti);
                            sessionStorage.setItem("pushNoti", userSnap.data().pushNoti);
                            sessionStorage.setItem("siteNoti", userSnap.data().siteNoti);
                            sessionStorage.setItem("bio", userSnap.data().bio);
                            sessionStorage.setItem("profileType", userSnap.data().profileType);
                            sessionStorage.setItem("bio", userSnap.data().bio);
                            sessionStorage.setItem("refCount", "0");
                            
                            if(localStorage.getItem("otherUserName") != null && localStorage.getItem("otherUserName") != ""){
                                
                                this.$router.push({ name: 'other-profile', params: { id: localStorage.getItem("otherUserName") } });
                                return;

                            }
                            
                            this.$router.push({name: 'home'});
                        }

                    }


                } catch (err) {
                    
                    this.errorText = "Google sign-in failed. Please try again"
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");

                } finally {
                    //
                }
            },

            async twitterSignIn(){

                this.loadingText = "Sign in with X...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                const twitterProvider = new TwitterAuthProvider();

                try{

                    const result = await signInWithPopup(auth, twitterProvider);

                    if (!result.user.email) {
                        // No email returned — reject this sign-in
                        await signOut(auth)
                        this.errorText = 'Sign-in failed: no email address was provided by this account.';
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return
                    }

                    this.user = result.user;

                    const userRef = doc(db, "Users", this.user.uid);
                    const userSnap = await getDoc(userRef);

                    if (userSnap.exists()){

                        if(userSnap.data().verified == "no"){
                            sessionStorage.setItem("email", result.user.email);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            sessionStorage.setItem("refCount", "10");
                            this.$router.push({name: 'verify'});
                            this.$refs.loadingModal.classList.remove("bg-active");
                            return;
                        }

                        if(userSnap.data().activityMonitor == "yes"){
                            //ip
                            this.updateIp(this.user.uid);
                        }

                        if(userSnap.data().auth == "yes"){

                            sessionStorage.setItem("email", result.user.email);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            this.$router.push({name: 'auth'});
                        }
                        else{
                            
                            sessionStorage.setItem("profilePic", userSnap.data().profilePic);
                            sessionStorage.setItem("profileBackground", userSnap.data().profileBackground);
                            sessionStorage.setItem("fullName", userSnap.data().name);
                            sessionStorage.setItem("userName", userSnap.data().displayId);
                            sessionStorage.setItem("fanCount", userSnap.data().fanCount);
                            sessionStorage.setItem("followingCount", userSnap.data().followingCount);
                            sessionStorage.setItem("followersCount", userSnap.data().followersCount);
                            sessionStorage.setItem("email", userSnap.data().email);
                            sessionStorage.setItem("userType", userSnap.data().type);
                            sessionStorage.setItem("regType", userSnap.data().regType);
                            sessionStorage.setItem("emailNoti", userSnap.data().emailNoti);
                            sessionStorage.setItem("pushNoti", userSnap.data().pushNoti);
                            sessionStorage.setItem("siteNoti", userSnap.data().siteNoti);
                            sessionStorage.setItem("bio", userSnap.data().bio);
                            sessionStorage.setItem("profileType", userSnap.data().profileType);
                            sessionStorage.setItem("bio", userSnap.data().bio);
                            sessionStorage.setItem("refCount", "0");
                            
                            if(localStorage.getItem("otherUserName") != null && localStorage.getItem("otherUserName") != ""){
                                
                                this.$router.push({ name: 'other-profile', params: { id: localStorage.getItem("otherUserName") } });
                                return;

                            }
                            
                            this.$router.push({name: 'home'});
                        }

                    }

                }
                catch(err){

                    console.log(err);
                    console.error('code:', err.code);
                    console.error('message:', err.message);
                    console.error('customData:', err.customData);
                    this.errorText = "Twitter sign-in failed. Please try again"
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");

                }
            },

            async metaSignIn(){

                this.errorText = "Meta sign in is unavailable at this time...";
                this.$refs.errorModal.classList.add("bg-active");
                return;

                this.loadingText = "Sign in with meta...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const facebookProvider = new FacebookAuthProvider();
                facebookProvider.addScope("email");

                try{

                    const result = await signInWithPopup(auth, facebookProvider);
                    this.user = result.user;

                }
                catch(err){
                    console.error(err);
                    this.errorText = "Meta sign in failed";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                }

            },

            appleSignIn(){
                this.errorText = "Apple sign in is unavailable at this time...";
                this.$refs.errorModal.classList.add("bg-active");
                return;
            },

            async updateIp(userId){

                let ipAddress, country, date, city;
                await axios.get('https://api.geoapify.com/v1/ipinfo?apiKey=5af290eb2cfd4bf3ae9db6b35af307c1')
                .then( response => {

                    ipAddress = ""+response.data.ip;
                    country = response.data.country.name;
                    city = response.data.city.name;
                    date = new Date().getTime();
            
                });

                await addDoc(collection(db, "UserIpAddress", userId, "IpAddress"), {
                    ip: ipAddress,
                    country: country,
                    date: date,
                    city: city
                });

                const usersRef = doc(db, "Users", userId);
                await updateDoc(usersRef, {
                    
                    status: "online",
                    
                });
            },

        }
        
    }
</script>